export default "__VITE_ASSET__NqwTfUsn__";